import useNotificationStore from '../store/useNotificationStore'

export const useNotifications = () => {
  const {
    preview,
    isPreviewLoading,
    list,
    listMeta,
    isListLoading,
    unreadCount,
    init,
    connect,
    disconnect,
    fetchUnreadCount,
    fetchPreview,
    fetchList,
    markAsRead,
    markAsUnread,
    markAllAsRead,
    deleteNotification,
    deleteAllRead,
    reset,
  } = useNotificationStore()

  return {
    preview,
    isPreviewLoading,
    list,
    listMeta,
    isListLoading,
    unreadCount,
    init,
    connect,
    disconnect,
    fetchUnreadCount,
    fetchPreview,
    fetchList,
    markAsRead,
    markAsUnread,
    markAllAsRead,
    deleteNotification,
    deleteAllRead,
    reset,
  }
}
